function fieldName(location = []) {
  const field = location.filter((part) => part !== 'body').at(-1);
  return typeof field === 'string'
    ? field.replaceAll('_', ' ').replace(/^./, (letter) => letter.toUpperCase())
    : '';
}

export function getApiErrorMessage(errorData, status) {
  const detail = errorData?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const messages = detail.map((error) => {
      if (typeof error === 'string') return error;
      const message = error?.msg || error?.message;
      if (!message) return null;
      const field = fieldName(error.loc);
      return field ? `${field}: ${message}` : message;
    }).filter(Boolean);
    if (messages.length) return messages.join(' ');
  }
  if (detail?.message) return detail.message;
  if (typeof errorData?.message === 'string') return errorData.message;
  return `Request failed with status ${status}`;
}
